"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
var initialState = {
    betValue: {
        MoneyValue: 0,
        Counter: 0
    },
    name: '',
    noOfChallenge: 0
};
function betReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case types_1.SET_BET_VALUE:
            return {
                betValue: {
                    MoneyValue: action.payload.betValue.MoneyValue,
                    Counter: action.payload.betValue.Counter
                },
                name: action.payload.name,
                noOfChallenge: action.payload.noOfChallenge
            };
        case types_1.RESET_BET_VALUE:
            return initialState;
        default:
            return state;
    }
}
exports.betReducer = betReducer;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/store/betting/reducers.ts
// module id = 2411
// module chunks = 5